/** Cairo is UTC+2 year-round. Same-day window is before 15:00. */
function cairoMinutes(date = new Date()) {
  const shifted = new Date(date.getTime() + 120 * 60 * 1000);
  return shifted.getUTCHours() * 60 + shifted.getUTCMinutes();
}

/** True before 15:00 Cairo. At 15:00 the order is the next working day. */
export function isBeforeSameDayCutoff(date = new Date()) {
  return cairoMinutes(date) < 15 * 60;
}

export function isAfterSameDayCutoff(date = new Date()) {
  return !isBeforeSameDayCutoff(date);
}

/**
 * Partner can request SDD at any time (no Cairo filter here).
 * Before 15:00 Cairo it is same-day; after that the API still creates it
 * and warns that it will be completed on the next working day.
 */
export function sameDayAvailable(_province, _date = new Date()) {
  return true;
}

export function isOrderConfirmedForSdd(order) {
  if (!order) return false;
  if (order.confirmedAt) return true;
  if (order.financialStatus === "Paid") return true;
  return !["Pending Confirmation", "Unreachable"].includes(order.status);
}

/** Statuses that allow switching between Blink SDD and brand default shipping. */
export const SHIPPING_SWITCH_STATUSES = ["New", "Pending Confirmation", "Sold Out"];

/** True when the order is currently on Blink / same-day delivery. */
export function isOnBlinkSdd(order) {
  if (!order) return false;
  return Boolean(
    order.sameDayDelivery
    || order.sddRequested
    || order.blinkTrackingId
    || order.blinkId
  );
}

/** Shared eligibility for both send-sdd and send-default-shipping. */
export function isEligibleForShippingSwitch(order) {
  if (!order || order.isReturn) return false;
  return SHIPPING_SWITCH_STATUSES.includes(order.status);
}

/**
 * Partner can send an existing order to Blink SDD.
 * Before 3:00 PM Cairo it is same-day. At or after 3:00 PM the API still
 * creates the shipment and returns a next-working-day warning.
 */
export function isEligibleForSendSdd(order) {
  if (!isEligibleForShippingSwitch(order)) return false;
  if (isOnBlinkSdd(order)) return false;
  return true;
}

/** Partner can move a Blink/SDD order back to the brand default carrier. */
export function isEligibleForSendDefaultShipping(order) {
  if (!isEligibleForShippingSwitch(order)) return false;
  return isOnBlinkSdd(order);
}
